var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeHeroColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 58,
    viewBox: "0 0 314 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.2009V0.771497H22.1922C26.4402 0.771497 30.0656 1.53381 33.0685 3.05843C36.0897 4.56469 38.3877 6.70467 39.9624 9.47839C41.5554 12.2337 42.3519 15.4759 42.3519 19.2048C42.3519 22.952 41.5462 26.1758 39.9349 28.876C38.3236 31.5579 35.989 33.6152 32.9312 35.048C29.8917 36.4808 26.2113 37.1971 21.8901 37.1971H7.03118V27.6086H19.9675C22.2379 27.6086 24.1239 27.2963 25.6254 26.6717C27.1268 26.0472 28.2438 25.1104 28.9762 23.8613C29.7269 22.6122 30.1023 21.06 30.1023 19.2048C30.1023 17.3311 29.7269 15.7514 28.9762 14.4656C28.2438 13.1797 27.1177 12.2062 25.5979 11.5449C24.0965 10.8652 22.2013 10.5254 19.9125 10.5254H11.8926V57.2009H0ZM30.3769 31.5211L44.3569 57.2009H31.2283L17.5505 31.5211H30.3769Z",
    fill: "url(#paint0_radial_710_2162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7564 57.2009V0.771497H88.6588V10.6081H62.6489V24.0542H86.7088V33.8907H62.6489V47.3644H88.7687V57.2009H50.7564Z",
    fill: "url(#paint1_radial_710_2162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.628 17.0005C128.408 14.7778 127.465 13.0511 125.799 11.8204C124.133 10.5897 121.872 9.97435 119.015 9.97435C117.074 9.97435 115.435 10.2499 114.099 10.801C112.762 11.3337 111.737 12.0776 111.023 13.0328C110.327 13.988 109.979 15.0717 109.979 16.2841C109.942 17.2944 110.153 18.1761 110.611 18.9292C111.087 19.6823 111.737 20.3344 112.561 20.8855C113.385 21.4182 114.337 21.8866 115.417 22.2907C116.497 22.6765 117.651 23.0071 118.878 23.2827L123.931 24.495C126.385 25.0461 128.637 25.7808 130.688 26.6993C132.739 27.6177 134.515 28.7474 136.016 30.0884C137.518 31.4293 138.68 33.009 139.504 34.8276C140.347 36.6461 140.777 38.731 140.795 41.0822C140.777 44.5355 139.898 47.5297 138.159 50.0646C136.437 52.5812 133.947 54.5374 130.688 55.9335C127.447 57.3112 123.538 58 118.96 58C114.419 58 110.464 57.302 107.095 55.9059C103.744 54.5099 101.126 52.4434 99.2399 49.7064C97.3723 46.9511 96.3927 43.5436 96.3011 39.4841H107.809C107.937 41.3761 108.478 42.9558 109.43 44.2233C110.4 45.4724 111.691 46.4184 113.302 47.0613C114.932 47.6858 116.772 47.9981 118.823 47.9981C120.837 47.9981 122.586 47.7042 124.069 47.1164C125.57 46.5286 126.733 45.7112 127.557 44.6641C128.381 43.6171 128.793 42.4139 128.793 41.0546C128.793 39.7872 128.418 38.7218 127.667 37.8584C126.934 36.9951 125.854 36.2603 124.426 35.6542C123.016 35.048 121.286 34.4969 119.235 34.001L113.11 32.458C108.368 31.3007 104.623 29.4914 101.877 27.0299C99.1301 24.5685 97.7659 21.2529 97.7843 17.0831C97.7659 13.6665 98.6723 10.6816 100.503 8.12827C102.353 5.57498 104.889 3.58195 108.111 2.14917C111.334 0.71639 114.996 0 119.098 0C123.272 0 126.916 0.71639 130.029 2.14917C133.16 3.58195 135.595 5.57498 137.335 8.12827C139.074 10.6816 139.971 13.639 140.026 17.0005H128.628Z",
    fill: "url(#paint2_radial_710_2162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.539 0.771497H195.431V37.4176C195.431 41.5322 194.452 45.1325 192.492 48.2185C190.551 51.3045 187.832 53.7108 184.335 55.4375C180.838 57.1458 176.764 58 172.113 58C167.444 58 163.361 57.1458 159.863 55.4375C156.366 53.7108 153.647 51.3045 151.706 48.2185C149.765 45.1325 148.795 41.5322 148.795 37.4176V0.771497H160.687V36.3981C160.687 38.5473 161.154 40.4576 162.088 42.1292C163.04 43.8008 164.377 45.1142 166.098 46.0694C167.819 47.0245 169.824 47.5021 172.113 47.5021C174.42 47.5021 176.425 47.0245 178.128 46.0694C179.849 45.1142 181.177 43.8008 182.11 42.1292C183.063 40.4576 183.539 38.5473 183.539 36.3981V0.771497Z",
    fill: "url(#paint3_radial_710_2162)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.216 0.771497H219.882L235.373 38.685H236.032L251.523 0.771497H266.189V57.2009H254.654V20.4722H254.187L239.63 56.9254H231.775L217.218 20.3344H216.751V57.2009H205.216V0.771497Z",
    fill: "url(#paint4_radial_710_2162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.988 57.2009V0.771497H313.89V10.6081H287.88V24.0542H311.94V33.8907H287.88V47.3644H314V57.2009H275.988Z",
    fill: "url(#paint5_radial_710_2162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_710_2162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-16.2233 95.1575) rotate(-19.5549) scale(390.431 5400.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeHeroColored);
export default __webpack_public_path__ + "static/media/resume_hero_colored.0c00f858a49aa9e2f364647354e9147b.svg";
export { ForwardRef as ReactComponent };